<template>
    <div>
        <PageTitle title="Listado de plazos"/>
        <section class="padding-vertical-content">
            <div class="container" v-if="!loading">
                <ListadoPlazos
                    :plazos="plazos"
                    :tipo_venta="tipo_venta"
                    :pagination="pagination"
                    @actualizar="actualizar"
                />
            </div>
            <div style="padding: 50px;" v-else>
                <LoaderComponent/>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import ListadoPlazos from '@/components/frontend/perfil/plazos/ListadoPlazos.vue';

    export default {
        data() {
            return {
                loading: false,
                plazos: null,
                tipo_plazo: this.$route.params.tipo_plazo,
                tipo_id: this.$route.params.tipo_id,
                pagination: {
                    currentPage: 1,
                    perPage: 10,
                    rows: 1,
                }
            }
        },
        created() {
            if(!this.isLogged){
                this.$router.push({name: 'login'});
            }
            this.getPlazos();
        },
        computed: {
            tipo_venta() {
                if (this.tipo_plazo === 'abono') {
                    return 'plazosAbono';
                }

                return 'plazosBase';
            },
            isLogged() {
                return this.$store.getters.isLogged;
            }
        },
        methods: {
            getPlazos(page) {
                this.loading = true

                if (this.tipo_plazo === 'abono') {
                    const params = {
                        filters: {
                            page: page,
                        },
                        page: page,
                        abonado_id: this.tipo_id
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.perfil.abono.plazos'), params).then(res => {
                        this.plazos = res.data.data;

                        this.setPaginationData(res.data.meta);
                    }).catch(e => {
                        if (e.response.data.error) {
                            this.$router.push('/perfil');
                        }
                    }).finally(() => {
                        this.loading = false;
                    });                
                } else {
                    const params = {
                        filters: {
                            page: page,
                        },
                        page: page,
                        base_id: this.tipo_id
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.perfil.base.plazos'), params).then(res => {
                        this.plazos = res.data.data;

                        this.setPaginationData(res.data.meta);
                    }).catch(e => {
                        if (e.response.data.error) {
                            this.$router.push('/perfil');
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            },
            actualizar(page) {
                this.getPlazos(page);
            },
            setPaginationData(meta) {
                this.pagination.currentPage = meta.current_page;
                this.pagination.perPage = meta.per_page;
                this.pagination.rows = meta.total;
            }
        },
        components: {
            PageTitle, ListadoPlazos
        }
    }
</script>